/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       RightArrowColorImagemage.tsx
 * @author     Christian Ascone
 * @date       9/18/19 11:06 AM
 */

import React from 'react';
import {Image} from "react-native";

export function RightArrowColorImage(props) {
    return (
        <Image
            {...props}
            style={[props.style]}
            source={
                require('../../assets/images/right_arrow_color.png')
            }
        />
    );
}